// extracted by mini-css-extract-plugin
export default {"navbar_brand":"CustomNavBrand_navbar_brand__oIZHO"};